export default {
    data () {
        return {
            billStatusOptions: [
                {status: 'open', msg: 'Non lu', color: 'warning'},
                {status: 'read', msg: 'Lu', color: 'info'},
                {status: 'answered', msg: 'Répondu', color: 'primary'},
                {status: 'closed', msg: 'Traité', color: 'success'}
            ]
        }
    },
    methods: {
        currentStatus (status) {
            return this.billStatusOptions.find(option => option.status === status)
        }
    }
}
